/* Корпус светлый в светлой теме и графитовый в тёмной; индикаторы
   те же, что на дашборде (--led-*). */
.faceplate {
  --fp-ear: #cdd5de;
  --fp-screw: #9aa6b2;
  --fp-screw-ring: #b4bec9;
  --fp-body: #e3e8ee;
  --fp-body-edge: #c5ced8;
  --fp-jack: #2b3440;
  --fp-jack-edge: #9aa6b2;
  --fp-cage: #f4f6f8;
  --fp-cage-edge: #94a3b8;
  --fp-text: #64748b;
  --fp-led-off: #b8c2cd;

  display: block;
  width: 100%;
  height: auto;
  overflow: visible;
}

:global(html.dark) .faceplate {
  --fp-ear: #273244;
  --fp-screw: #0b1220;
  --fp-screw-ring: #3b4a60;
  --fp-body: var(--dev-body);
  --fp-body-edge: var(--dev-edge);
  --fp-jack: var(--dev-hole);
  --fp-jack-edge: #2a3648;
  --fp-cage: #8ea3b8;
  --fp-cage-edge: #b4c3d2;
  --fp-text: #7c8da3;
  --fp-led-off: #1e293b;
}

.ear {
  fill: var(--fp-ear);
}
.screw {
  fill: var(--fp-screw);
  stroke: var(--fp-screw-ring);
  stroke-width: 1;
}
.body {
  fill: var(--fp-body);
  stroke: var(--fp-body-edge);
  stroke-width: 1;
}

.jack {
  fill: var(--fp-jack);
  stroke: var(--fp-jack-edge);
  stroke-width: 1;
}
.cage {
  fill: var(--fp-cage);
  stroke: var(--fp-cage-edge);
  stroke-width: 0.75;
}

.num {
  font: 600 7.5px var(--mono);
  fill: var(--fp-text);
  text-anchor: middle;
  font-variant-numeric: tabular-nums;
}

/* Надписи шелкографией — как на корпусе */
.silk {
  font: 600 7px var(--sans);
  fill: var(--fp-text);
  letter-spacing: 0.06em;
}

.ledOff {
  fill: var(--fp-led-off);
}

/* Линк поднимается: сначала янтарный — согласование, затем зелёный */
.ledUp {
  fill: var(--fp-led-off);
  animation: linkUp 0.6s ease-out both;
}

@keyframes linkUp {
  0% {
    fill: var(--fp-led-off);
  }
  35% {
    fill: var(--led-checked);
  }
  60% {
    fill: var(--led-checked);
  }
  100% {
    fill: var(--led-clean);
  }
}

.pwr {
  fill: var(--led-clean);
}

/* SYS мигает при загрузке, затем горит ровно */
.sys {
  fill: var(--fp-led-off);
  animation: sysBoot 1.2s steps(1, end) both;
}

@keyframes sysBoot {
  0% {
    fill: var(--led-checked);
  }
  17% {
    fill: var(--fp-led-off);
  }
  33% {
    fill: var(--led-checked);
  }
  50% {
    fill: var(--fp-led-off);
  }
  67% {
    fill: var(--led-checked);
  }
  84% {
    fill: var(--fp-led-off);
  }
  100% {
    fill: var(--led-clean);
  }
}

/* Без движения — сразу итоговое состояние, без задержек волны */
@media (prefers-reduced-motion: reduce) {
  .ledUp,
  .sys {
    animation: none;
    fill: var(--led-clean);
  }
}
